import axios from "axios";
import {handlerError} from "../helpers";

const ROUTE = {
    frame: "api/admin-settings/frame",
    contactUsAndFiles: '/api/art-print-form/submit',
    loggerPayment: '/api/logger/payment',
    adminSettings: 'api/admin-settings',
    media: 'api/media'
};

export const apiGetFrame = async () => {
    try {
        const res = await axios(ROUTE.frame);
        if (!res.data.success) {
            handlerError(Error("missing data"));
        }
        return (res.data && res.data.data) || [];
    } catch (err) {
        handlerError(err);
    }
};

export const contactUsAndFiles = async (payload, callback) => {
    try {
        const res = await axios({
            url: ROUTE.contactUsAndFiles,
            method: 'post',
            data: payload,
            headers: {"Content-Type": "multipart/form-data"},
            onUploadProgress: progressEvent => callback(progressEvent.loaded)
        });

        return res.data;
    } catch (err) {
        handlerError(err);
    }
}

export const apiLoggerPayment = async (message = '', userEmail = '') => {

    try {
        await axios({
            url: ROUTE.loggerPayment,
            method: 'post',
            headers: {'Content-Type': 'application/json'},
            data: {
                message,
                userEmail,
            }
        })
    } catch (err) {
        console.log(err);
    }
}


export const apiGetField = async (fieldName) => {

    try {
        const res = await axios({
            url: `${ROUTE.adminSettings}/${fieldName}`,
            method: 'get',
            headers: {'Content-Type': 'application/json'},
        })

        return res.data || null;
    } catch (err) {
        console.log(err);
    }
}


export const apiGetAllFields = async (list) => {
    try {
        const data = await Promise.all(list.map(async (field) => apiGetField(field)));
        const firstChildData = data.map(item => {
            if(Array.isArray(item.data)) {
                return item.data.shift();
            }
            return null
        })
        let results = firstChildData.filter(Boolean);
        const merge = list.filter(value => !results.some(field => field.type === value));
        if(merge.length) {
            results = results.concat(merge.map((key, index) => ({ type: key, value: '', _id: index })))
        }
        console.log(results, 'results')
        return results;
    } catch (err) {
        console.log(err);
    }
}

export const apiGetMedia = async (type, limit = 0) => {
    try {
        const res = await axios.get(`${ROUTE.media}/${type}/${limit}`)
        return res.data && res.data.data || [];
    } catch (err) {
        console.log(err);
    }
}


// WEBPACK FOOTER //
// ./src/api/public.js